import { Crown, Flame, Star, Shield, Gem, Zap, Circle } from "lucide-react";

const TIER_CONFIG = {
  free:     { label: "Free",           color: "bg-gray-100 text-gray-500 border-gray-200",       Icon: Circle  },
  wanderer: { label: "Wanderer",       color: "bg-cyan-50 text-cyan-700 border-cyan-200",         Icon: Zap     },
  kindred:  { label: "Kindred Spirit", color: "bg-purple-50 text-purple-700 border-purple-200",   Icon: Flame   },
  quester:  { label: "Quester",        color: "bg-amber-50 text-amber-700 border-amber-200",      Icon: Star    },
  pilgrim:  { label: "Pilgrim",        color: "bg-emerald-50 text-emerald-700 border-emerald-200",Icon: Shield  },
  guardian: { label: "Guardian",       color: "bg-rose-50 text-rose-700 border-rose-200",         Icon: Gem     },
  spire:    { label: "Spire",          color: "bg-yellow-50 text-yellow-700 border-yellow-200",   Icon: Crown   },
};

const TierBadge = ({ tierKey = "free", size = "sm" }) => {
  const config = TIER_CONFIG[(tierKey || "free").toLowerCase()] || TIER_CONFIG.free;
  const { Icon } = config;

  const sizeClass  = size === "lg" ? "px-3 py-1.5 text-sm gap-1.5" : "px-2 py-0.5 text-xs gap-1";
  const iconSize   = size === "lg" ? 13 : 10;

  return (
    <span className={`inline-flex items-center rounded-full border font-semibold font-outfit ${config.color} ${sizeClass}`}>
      <Icon size={iconSize} strokeWidth={2.5} />
      {config.label}
    </span>
  );
};

export default TierBadge;
